<template>
  <div v-if="open" id="NfeDetails">
    <v-dialog v-model="open" persistent max-width="700">
      <v-card class="align-center">
        <v-card-text>
          <h1 class="pt-5">Detalhes da Nota</h1>
          <div class="mt30"></div>
          <h3><strong>Carga</strong></h3>
          <v-divider></v-divider>
          <p>
            <b>Id da Carga:</b> {{ node[0].cargoId }} <br />
            <b>Id do Transbordo:</b> {{ node[0].transhipmentId }} <br />
            <b>Nome do Transbordo:</b> {{ node[0].transhipmentName }} <br />
            <b>Preço do Transbordo:</b>
            {{ transformPrice(node[0].transhipmentPrice) }} <br />
            <b>Id do Embarque:</b> {{ node[0].boardingId }} <br />
            <b>Número de embarque:</b> {{ node[0].boardingNumber }} <br />
            <b>Entrega Direta? </b
            >{{ node[0].isDirectDelivery ? "Sim" : "Não" }} <br />
          </p>

          <h3><strong>Parada</strong></h3>
          <v-divider></v-divider>

          <p>
            <b>Id do Destinatário:</b> {{ node[0].recipientId }} <br />
            <b>Nome do Destinatário:</b> {{ node[0].recipientName }} <br />
            <b>CPF/CNPJ do Destinatário:</b>
            {{ transformCpfOrCnpj(node[0].recipientCpfOrCnpj) }} <br />
            <b>Cidade:</b> {{ node[0].cityName }}
          </p>

          <h3><strong>Entrega</strong></h3>
          <v-divider></v-divider>

          <p>
            <b>Previsão de Entrega:</b>
            {{ transformDate(node[0].deliveryForecast) }} <br />
            <b>Data de Emissão:</b>
            {{ transformDateTime(node[0].emissionDate) }}
            <br />
            <b>Data de Autorização:</b>
            {{ transformDateTime(node[0].authorizationDate) }} <br />
            <b>Custo do Frete:</b> {{ transformPrice(node[0].costFreight) }}
            <br />
            <b>Enviado por:</b> {{ node[0].senderName }} <br />
            <b>Número:</b> {{ node[0].numberCte }} <br />
            <b>Chave de acesso:</b> {{ node[0].accesskeyCte }} <br />
            <b>Preço:</b> {{ transformPrice(node[0].price) }} <br />
            <b>Peso:</b> {{ transformWeight(node[0].weight) }} <br />
          </p>

          <h3><strong>Nota Fiscal</strong></h3>
          <v-divider></v-divider>

          <p>
            <b>Número:</b> {{ node[0].number }} <br />
            <b>Chave de acesso:</b> {{ node[0].accesskey }} <br />
            <b>Status:</b> {{ node[0].nfeStatus[0].name }} <br />
            <b>Data de conclusão:</b>
            {{
              transformDate(node[0].completionDate) !== "01/01/1"
                ? transformDate(node[0].completionDate)
                : "-"
            }}
            <br />
            <b>Justificativa de Quarentena:</b>
            {{
              node[0].justificationQuarantine
                ? node[0].justificationQuarantine
                : "-"
            }}
            <br />
          </p>

          <div class="mt10"></div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="info" class="flex-grow-1" large @click="close()">
            VOLTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import maskDateTime from "../../utils/maskDateTime";
import maskCPF from "../../utils/maskCPF";
import maskCNPJ from "../../utils/maskCNPJ";
import maskData from "../../utils/maskData";
import maskPrice from "../../utils/maskPrice";
import maskWeight from "../../utils/maskWeight";

export default {
  name: "NfeDetails",
  props: {
    open: {
      default: false,
      type: Boolean,
    },
    node: {
      default: [],
      type: [],
    },
  },
  methods: {
    close() {
      this.$emit("closeNfeDetails");
    },
    transformDateTime(date) {
      return maskDateTime(date);
    },
    transformWeight(weight) {
      return maskWeight(weight);
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    },
    transformDate(date) {
      return maskData(date);
    },
  },
};
</script>
